import React from "react";
import { Mail } from "lucide-react";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import SEO from "../Components/SEO";
import { SEO_DATA } from "../config/seoData";

const SUPPORT_EMAIL = "customercare@indiaboats.in";
const DELETION_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
  "Data Deletion Request"
)}&body=${encodeURIComponent(
  "Name:\nRegistered Mobile Number:\nEmail Address:\n"
)}`;

export default function DataDeletion() {
  return (
    <>
      <SEO {...SEO_DATA.dataDeletion} />
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="ibddel-page">
        <div className="ibddel-container">
          <span className="ibddel-eyebrow">Your Privacy</span>
          <h1 className="ibddel-title">Data Deletion Instructions</h1>

          <div className="ibddel-card">
            <p className="ibddel-text">
              To request deletion of personal data held by India Boats, email{" "}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> with the
              subject &ldquo;Data Deletion Request&rdquo;.
            </p>
            <p className="ibddel-text">
              Please include your name, registered mobile number and email
              address.
            </p>
            <p className="ibddel-text">
              We will verify your identity and process the request in accordance
              with applicable law.
            </p>

            <p className="ibddel-email">
              <Mail size={18} aria-hidden="true" />
              <span>
                Email:{" "}
                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              </span>
            </p>

            <a href={DELETION_MAILTO} className="ibddel-btn">
              Send Data Deletion Request
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
